/**
 * Copy for the "who you are dealing with" panel — OND-81.
 *
 * What it must not say: that anybody is "verified" in the identity sense. The
 * flag shown is the registry's own badge, and the word for it is the one the
 * catalogue already uses — "Confirmed on ONDO" — never "identity verified",
 * which `ondo.identity_standing()` cannot yet support (20261012096101
 * decision 6).
 */
export const COUNTERPARTY_COPY = {
  /** The control on a row that names somebody. */
  check: "Check who this is",
  title: "Who you are dealing with",
  close: "Close",
  loading: "Reading the record…",
  fallbackError: "That record could not be read.",
  confirmed: "Confirmed on ONDO",
  notConfirmed: "Not yet confirmed on ONDO",
  person: "Person",
  organisation: "Organisation",
  since: (day: string) => `On ONDO since ${day}`,
  firms: "Works at",
  noFirms: "Holds no seat at any firm on ONDO.",
  seat: (title: string | null, level: string) =>
    `${title ? `${title} · ` : ""}${LEVEL_WORDS[level] ?? level}`,
  relations: "Your record together",
  noRelations: "No record between you yet.",
  current: "Current",
  ended: "Ended",
  relation: (kind: string) => RELATION_WORDS[kind] ?? kind,
  standing: (word: string) => STANDING_WORDS[word] ?? word,
  affiliations: "What they have published",
  noAffiliations: "Nothing published to you.",
  /** Why there is no search box, said once. */
  noDirectory:
    "ONDO has no directory. You can read this because they put their name on something addressed to you.",
} as const;

const LEVEL_WORDS: Record<string, string> = {
  viewer: "may see what the firm holds, cannot commit it",
  editor: "may act for the firm",
  admin: "may commit the firm",
};

const RELATION_WORDS: Record<string, string> = {
  mandate: "Appointed to represent",
  representation_request: "Asked to represent",
  consignment: "Consignment",
  sale: "Sale",
  loan: "Loan",
  collection_share: "Collection shared",
  affiliation_claim: "Affiliation claim",
};

const STANDING_WORDS: Record<string, string> = {
  current: "current",
  ended: "ended",
  open: "awaiting your answer",
  offered: "offered",
  accepted: "accepted",
  declined: "declined",
  withdrawn: "withdrawn",
  granted: "granted",
  unregistered: "awaiting the buyer",
  proposed: "proposed",
  agreed: "agreed",
  out: "out on loan",
  returned: "returned",
  cancelled: "cancelled",
  unanswered: "unanswered",
  confirmed: "confirmed",
  disputed: "disputed",
  no_recall: "no recollection",
  sold: "sold",
  expired: "expired",
};
